module.exports = __webpack_public_path__ + "static/media/room_control_panel.a66b7a33.png";


//////////////////
// WEBPACK FOOTER
// ./src/room_control_panel.png
// module id = 201
// module chunks = 0